import styles from './SolutionFlatTitle.module.scss';

import React, { FC, HTMLAttributes } from 'react';

import type { SolutionPickerModule as SolutionPickerModuleType } from 'api/contentful/contentTypes.cloverdotcom';
import { TextV2 } from 'components/TextV2/TextV2';
import type { FlatEntry } from 'services/cms/flattenContentful';

interface ISolutionFlatTitleProps extends HTMLAttributes<HTMLElement> {
  entry?: FlatEntry<SolutionPickerModuleType>;
}

export const SolutionFlatTitle: FC<ISolutionFlatTitleProps> = ({ entry }) => {
  if (!entry) return null;
  const { title, titleColor, isUsedWithEmptyCartPage, variant, headingTagName = 'h2' } = entry;

  return (
    <div className={styles.solutionPickerModuleHero}>
      <TextV2
        hasId
        isMarkdown
        value={title}
        entry={{ ...entry, field: 'title' }}
        tagName={headingTagName}
        variant={variant === 'Flat' || isUsedWithEmptyCartPage ? 'h2-bold' : 'h2'}
        className={styles.solutionPickerModuleTitle}
        style={{ color: titleColor }}
      />
    </div>
  );
};
